/**
 * sl-w252: PDF context chip for Copilot chat (Weg B — Canvas Selection).
 * Shows selected PDF attachment from the canvas with a close button.
 */
import { SignalWatcher, WithDisposable } from '@blocksuite/affine/global/lit';
import { ShadowlessElement } from '@blocksuite/affine/std';
import { AttachmentIcon } from '@blocksuite/icons/lit';
import { html } from 'lit';
import { property } from 'lit/decorators.js';

import type { PdfContextAttachment } from '../ai-chat-content/type';

export class ChatPanelPdfContextChip extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor pdf!: PdfContextAttachment;

  @property({ attribute: false })
  accessor onRemove: ((pdf: PdfContextAttachment) => void) | undefined;

  override render() {
    const tooltip = `PDF: ${this.pdf.name} — AI will search via embeddings`;

    return html`<chat-panel-chip
      .state=${'finished'}
      .name=${this.pdf.name}
      .tooltip=${tooltip}
      .icon=${AttachmentIcon()}
      .closeable=${true}
      .onChipDelete=${this._handleRemove}
    ></chat-panel-chip>`;
  }

  private readonly _handleRemove = () => {
    this.onRemove?.(this.pdf);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'chat-panel-pdf-context-chip': ChatPanelPdfContextChip;
  }
}
